// extracted by mini-css-extract-plugin
export default {"btnCard":"ButtonCard_btnCard__GeXLl"};